import { dispatchAdobeEvent } from "@intergamma/adobe-tracking"

import { useMutation } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"

import { useBaseApiService } from "~/features/shared/ServicesContext"

import { isAxiosError } from "~/helpers/isAxiosError"
import { log } from "~/helpers/tracking/datadog-logging"
import { TranslatedError } from "~/helpers/TranslatedError"

interface UpdatePasswordBody {
  oldPassword: string
  newPassword: string
}

export function useUpdatePassword() {
  const baseApiService = useBaseApiService()

  const { t } = useTranslation(["change-password", "errors"])

  function updatePassword(body: UpdatePasswordBody) {
    return baseApiService.updatePassword(body).catch((error) => {
      if (isAxiosError(error)) {
        const statusCode = error.response?.status

        if (statusCode === 400) {
          throw new TranslatedError(t("change-password:invalidPassword"))
        }
      }

      log.error("Update password failed", {}, error)

      throw new TranslatedError(`${t("change-password:errorMessage")} ${t("errors:ContactCustomerSupport")}`)
    })
  }

  return useMutation({
    mutationFn: updatePassword,
    onSuccess: () => {
      dispatchAdobeEvent({ type: "login_change_password" })
    },
    throwOnError: false,
  })
}
